
import select from 'dom-select'
import { set } from '../utils/general'

const isElementInViewport = (el) => {
  const rect = el.getBoundingClientRect()
  const windowHeight = (window.innerHeight || document.documentElement.clientHeight)

  return (rect.top <= windowHeight) && ((rect.top + rect.height) >= 0)
}

const checkVisibility = () => {
  const elements = select.all('.animated')

  elements.forEach((element) => {
    isElementInViewport(element) && set(element, 'is-animated')
  })
}

window.addEventListener('scroll', checkVisibility, false)
window.addEventListener('load', checkVisibility, false)
